import { $authHost } from './index.js'

export const hostsDataApi = {
    // Получение данных хоста по host
    getHostDataByHostId: async (host) => {
        try {
            const { data } = await $authHost.get(`/api/notes/by-host/${encodeURIComponent(host)}`)
            return data
        } catch (error) {
            console.error('Error getting host data by host:', error);
            throw error;
        }
    },

    // Создание или обновление данных хоста (upsert)
    upsertHostData: async (host, note_for_engineer = null, note_for_guest = null) => {
        try {
            const { data } = await $authHost.post('/api/notes/upsert', {
                host,
                note_for_engineer,
                note_for_guest
            })
            return data
        } catch (error) {
            console.error('Error upserting host data:', error);
            throw error;
        }
    },

    // Обновление данных хоста
    updateHostData: async (host, note_for_engineer = null, note_for_guest = null) => {
        try {
            const { data } = await $authHost.put(`/api/notes/${encodeURIComponent(host)}`, {
                note_for_engineer,
                note_for_guest
            })
            return data
        } catch (error) {
            console.error('Error updating host data:', error);
            throw error;
        }
    },

    // Удаление данных хоста
    deleteHostData: async (host) => {
        try {
            const { data } = await $authHost.delete(`/api/notes/${encodeURIComponent(host)}`)
            return data
        } catch (error) {
            console.error('Error deleting host data:', error);
            throw error;
        }
    }
}

